import { defaultSchema } from "../../../../lib/validation";
import { formatDate } from '../../../../lib/textFormatting';

export const requestTypes = {
  NO_LONGER_OWN: "I no longer own this vehicle",
  WRITTEN_OFF: "This vehicle has been written-off",
};

export const newOwnerTypes = {
  PRIVATE: "Private",
  DEALER: "Non-Audi Dealer",
  AUDI: "Audi Dealer",
};

export const validationSchema = {
  requestType: {
    presence: {message: "Please choose a request type", allowEmpty: false}
  },
  firstName: defaultSchema.firstName,
  lastName: defaultSchema.lastName,
  email: defaultSchema.emailAddress,
  phone: defaultSchema.mobile,
  address: { presence: {message: "Please enter your address", allowEmpty: false} },
  suburb: { presence: {message: "Please enter your suburb", allowEmpty: false} },
  postCode: defaultSchema.postcode,
  newOwnerType: function(value, attributes, attributeName, options, constraints) {
    if (attributes.requestType === requestTypes.NO_LONGER_OWN) {
      return { presence: {message: "This field is required", allowEmpty: false} };
    }
    return;
  },
  dealerName: function(value, attributes, attributeName, options, constraints) {
    if (attributes.requestType === requestTypes.NO_LONGER_OWN && attributes.newOwnerType === newOwnerTypes.AUDI) {
      return { presence: {message: "This field is required", allowEmpty: false} };
    }
    return;
  },
  dateOfChange: function(value, attributes, attributeName, options, constraints) {
    if (attributes.requestType === requestTypes.NO_LONGER_OWN) {
      return { presence: {message: "Please enter the date of sale", allowEmpty: false} };
    } else if (attributes.requestType === requestTypes.WRITTEN_OFF) {
      return { presence: {message: "Please enter the write-off date", allowEmpty: false} };
    }
    return;
  },
  files1: function(value, attributes, attributeName, options, constraints) {
    if (attributes.requestType === requestTypes.WRITTEN_OFF) {
      return { isFile: {message: "A supporting document is required"} };
    }
    return;
  },
  consent: defaultSchema.requiredField,
};

export const mapValues = (values, vehicle, homeState) => {
  var mappedValues = {
    'VIN': vehicle.vin,
    'Registration': vehicle.regoNo,
    'State': homeState,
    'Request type': values.requestType,
    'consent': values.consent,
    'optIn': values.optIn,
    'optOut': !values.optIn,
  };
  var user = {
    'First name': values.firstName,
    'Last name': values.lastName,
    'Email': values.email,
    'Contact number': values.phone,
    'Address': values.address,
    'Suburb': values.suburb,
    'Postcode': values.postCode
  };
  mappedValues['Your details'] = user;
  if (values.requestType === requestTypes.NO_LONGER_OWN) {
    mappedValues['New owner details'] = {
      'Type': values.newOwnerType,
      'Name': values.newOwnerType === newOwnerTypes.AUDI ? values.dealerName : "",
      "Last name": "",
      "Email": "",
      "Contact number": "",
      "Address": "",
      "Suburb": "",
      "Postcode": ""
    };
  }
  if (values.requestType === requestTypes.NO_LONGER_OWN) {
    mappedValues['Date of sale'] = formatDate(values.dateOfChange);
  }
  if (values.requestType === requestTypes.WRITTEN_OFF) {
    mappedValues['Write-off date'] = formatDate(values.dateOfChange);
  }
  return mappedValues;
}
